import { getSiteUrl } from "@clockwise/client-commons/src/config/api";
import { Close } from "@clockwise/design-system/icons";
import React from "react";
import chatBannerImg from "../../assets/banners/chat_banner_asset.png";
import { TrackingEvents, track } from "../../util/analytics.util";

type Props = {
  onDismiss: () => void;
};

export function ChatBanner({ onDismiss }: Props) {
  const handleClick = () => {
    track(TrackingEvents.CHAT.JOIN_WAITLIST_BANNER.CLICKED);
  };

  const handleDismiss = () => {
    track(TrackingEvents.CHAT.JOIN_WAITLIST_BANNER.DISMISSED);
    onDismiss();
  };

  return (
    <div className="cw-relative cw-group">
      <div
        className={`
        cw-absolute cw-top-0 cw-right-0 cw-pt-1.5 cw-pr-1.5
        cw-invisible group-hover:cw-visible group-hover:cw-opacity-50
        cw-text-onEmphasis cw-cursor-pointer
      `}
        onClick={handleDismiss}
      >
        <Close fontSize="small" />
      </div>
      <a
        className={`
        cw-flex cw-rounded-lg
        cw-pb-5 cw-no-underline cw-overflow-hidden
        cw-border cw-border-solid cw-border-emphasis
        cw-heading-base cw-text-14 cw-text-onEmphasis cw-leading-tight
        `}
        style={{
          background: "linear-gradient(180deg, #4459DD 19.26%, #FFE5FF 130.89%)",
        }}
        href={`${getSiteUrl()}/ai`}
        target="_blank"
        onClick={handleClick}
      >
        <div className="cw-flex">
          <img src={chatBannerImg} className="cw-w-[150px]" />
        </div>
        <div className="cw-flex cw-flex-col cw-justify-end cw-items-center cw-mx-3">
          <div className="">Clockwise AI has entered the chat</div>
          <div
            className={`
            cw-bg-accent-emphasis hover:cw-bg-accent-emphasis-hover
            cw-rounded-lg cw-border cw-border-solid cw-border-accent-emphasis
            cw-p-2 cw-mt-3 cw-self-stretch cw-text-center
            `}
          >
            Join waitlist
          </div>
        </div>
      </a>
    </div>
  );
}
